import * as ToastPrimitive from "@radix-ui/react-toast";

import { cn } from "../../handlers/cn.utils";

function ConfirmToastProvider({ children, ...props }) {
	return (
		<ToastPrimitive.Provider swipeDirection="right" {...props}>
			{children}
			<ToastPrimitive.Viewport className="fixed bottom-0 right-0 flex flex-col gap-2 p-4 w-md max-w-full m-0 list-none z-50 outline-hidden" />
		</ToastPrimitive.Provider>
	);
}

// Toast root
function ConfirmToast({ className, ...props }) {
	return (
		<ToastPrimitive.Root
			duration={Infinity}
			className={cn(
				"bg-[#f1f6fb] border border-gray-300 rounded-md shadow-xs p-4 flex flex-col gap-3 w-md max-w-full",
				className,
			)}
			{...props}
		/>
	);
}

function ConfirmToastTitle({ className, ...props }) {
	return <ToastPrimitive.Title className={cn("text-sm font-semibold text-gray-800", className)} {...props} />;
}

function ConfirmToastDescription({ className, ...props }) {
	return <ToastPrimitive.Description className={cn("text-sm text-gray-600", className)} {...props} />;
}

function ConfirmToastAction({ onYes, onNo, className }) {
	return (
		<div className={cn("flex justify-end gap-6 text-sm font-medium text-gray-700", className)}>
			<button onClick={onYes} className="hover:underline">
				Yes
			</button>
			<button onClick={onNo} className="hover:underline">
				No
			</button>
		</div>
	);
}

export { ConfirmToast, ConfirmToastAction, ConfirmToastDescription, ConfirmToastProvider, ConfirmToastTitle };
